export default (params) => ({
  trigger: {
    name: 'product_collection.select_option',
    params: params,
  },
  config: {
    schema: {
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      item_id: {
        type: 'integer',
      },
      sub_feature: {
        enum: [
          'drop_down_selector',
          'direct_collection',
        ],
      },
    },
    event: {
      name: 'select_collection_item',
      params: {
        property_value: null,
        property_name: null,
      },
    },
    nonInt: false,
  },
});
